// extracted by mini-css-extract-plugin
export default {"btnHolder":"schedule-expiry_btnHolder__bR0d3","teams-button-default":"schedule-expiry_teams-button-default__U8DlK"};